'use strict'

var Backbone = require('backbone')
var Marionette = require('marionette')
var App = require('app')

/* Views */
var List = require('./list')
var EditNew = require('./edit_new')

var ClientMailReportsList = function () {
  /* Routes ----------------------------------------------------------------- */
  /* API -------------------------------------------------------------------- */
  var API = {
    listMailReports: function (options) {
      new List(options)
    },
    editMailReport: function (options) {
      new EditNew(options)
    }
  }

  /* Listeners -------------------------------------------------------------- */
  App.globalChannel.on('client-mailreports:list', function (options) {
    API.listMailReports(options)
  })

  App.globalChannel.on('client-mailreports:new', function (options) {
    API.editMailReport(options)
  })

  App.globalChannel.on('client-mailreports:edit', function (options) {
    API.editMailReport(options)
  })
}

module.exports = ClientMailReportsList



// WEBPACK FOOTER //
// ./js/modules/client-mailreports/index.js